import React from "react";
import { Fade, Slide } from "react-reveal";
import { Container, Row, Col } from "react-bootstrap";
import { MainLayout } from "../main-layout/main-layout.component";
import {
  WrapSection1,
  WrapTitle,
  WrapSection2,
  WrapParagraph,
  WrapSubTitle,
  WrapContent,
} from "./child-safety.styled";

export const ChildSafety = () => {
  return (
    <MainLayout>
      <Fade top>
        <WrapSection1>
          <Container style={{ position: "relative", paddingTop: "80px", paddingBottom: "60px" }}>
            <Row>
              <Col className="text-center">
                <WrapTitle>Children’s Safety & Protection Policy</WrapTitle>
                <WrapParagraph size={"20px"}>
                  Snapkyu is committed to protecting the safety, privacy, and well-being of children.
                </WrapParagraph>
                <div className="security" />
              </Col>
            </Row>
          </Container>
        </WrapSection1>
      </Fade>

      <Slide left>
        <WrapSection2>
          <Container style={{ width: "80%", margin: "auto" }}>
            <Row>
              <Col>
                <WrapContent>
                  <WrapParagraph>
                    Snapkyu is committed to protecting the safety, privacy, and well-being of children. Our platform is
                    designed for a general audience and is not intended for children under the age of 13.
                  </WrapParagraph>

                  <WrapSubTitle>No Intentional Data Collection from Children</WrapSubTitle>
                  <WrapParagraph>
                    Snapkyu does not knowingly collect, use, or store personal information from children under 13 years
                    of age without verifiable parental or legal guardian consent. If we become aware that personal
                    information from a child has been collected without proper consent, we will take immediate steps to
                    delete such information from our systems.
                  </WrapParagraph>

                  <WrapSubTitle>Protection Against Harmful Content</WrapSubTitle>
                  <WrapParagraph>Snapkyu strictly prohibits any content that:</WrapParagraph>
                  <WrapParagraph>
                    <ul>
                      <li>Exploits, abuses, or endangers children</li>
                      <li>Depicts children in sexual, violent, or inappropriate contexts</li>
                      <li>Encourages harmful behavior toward minors</li>
                    </ul>
                  </WrapParagraph>
                  <WrapParagraph>
                    We use a combination of automated monitoring, manual review, and user reporting mechanisms to detect
                    and remove such content promptly.
                  </WrapParagraph>

                  <WrapSubTitle>Reporting &amp; Enforcement</WrapSubTitle>
                  <WrapParagraph>
                    Users can report content or behavior that may violate child safety standards through our in-app
                    reporting tools or by contacting us directly. Reports involving child safety are treated with the
                    highest priority and may be escalated to relevant authorities when required by law.
                  </WrapParagraph>

                  <WrapSubTitle>Parental Rights</WrapSubTitle>
                  <WrapParagraph>
                    Parents or legal guardians who believe that Snapkyu may have collected personal information from a
                    child may contact us to:
                  </WrapParagraph>
                  <WrapParagraph>
                    <ul>
                      <li>Review the information</li>
                      <li>Request correction</li>
                      <li>Request deletion</li>
                    </ul>
                  </WrapParagraph>

                  <WrapSubTitle>Contact for Child Safety Issues</WrapSubTitle>
                  <WrapParagraph>
                    For child safety or children’s privacy concerns, please contact us at:
                    <br />
                    info@snapkyu.com
                  </WrapParagraph>
                </WrapContent>
              </Col>
            </Row>
          </Container>
        </WrapSection2>
      </Slide>
    </MainLayout>
  );
};
